import _ from 'lodash';
import template from './forgotPassword.html';

class ForgotPasswordController {
    /*@ngInject*/
    constructor($log, $state, userService, $scope, $timeout, $q, constants) {
        this.$log = $log;
        this.$state = $state;
        this.userService = userService;
        this.captchaToken = null;
        this.username = null;
        this.constants = constants;
        this.widgetId = null;
        this.isBusy = false;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$scope = $scope;
    }

    $onInit() {
        this.loadTurnstileScript().then(() => {
            this.$timeout(() => this.renderTurnstile());
        });
    }

    loadTurnstileScript() {
        var deferred = this.$q.defer();

        if (window.turnstile) {
            deferred.resolve();
            return deferred.promise;
        }

        var script = document.createElement("script");
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
        script.async = true;
        script.defer = true;
        script.onload = () => deferred.resolve();
        script.onerror = () => deferred.reject();
        document.head.appendChild(script);

        return deferred.promise;
    }

    renderTurnstile() {
        var container = document.getElementById("forgotPasswordTurnstile");
        if (!container) return;

        if (this.widgetId != null && window.turnstile) {
            window.turnstile.remove(this.widgetId);
        }

        this.captchaToken = null;

        this.widgetId = window.turnstile.render(container, {
            sitekey: this.constants.turnstileSiteKey,
            size: 'compact',
            appearance: 'always',
            callback: (token) => {
                this.captchaToken = token;
                this.$scope.$apply();
            },
            'expired-callback': () => {
                this.captchaToken = null;
                this.$scope.$apply();
            },
            'error-callback': () => {
                this.captchaToken = null;
                this.$scope.$apply();
            }
        });
    }

    formFieldsPopulated() {
        return (!_.isNil(this.username) && !_.isNil(this.password));
    }

    $onDestroy() {
        if (this.widgetId != null && window.turnstile) {
            window.turnstile.remove(this.widgetId);
            this.widgetId = null;
        }
    }

    isValid() {
        return !_.isEmpty(this.username);
    }

    submit() {
        if (!this.captchaToken) {
            this.error = 'Verification is currently in progress. Please wait a moment and try again.';
            return;
        }

        this.isBusy = true;
        return this.userService.forgotPassword(this.username, this.captchaToken)
            .then((result) => {
                return this.$state.go('login.home',
                        {
                            message: result
                        });
                },
                (error) => {
                    // Reset turnstile to get a fresh token for retry
                    this.captchaToken = null;
                    if (this.widgetId != null && window.turnstile) {
                        window.turnstile.reset(this.widgetId);
                    }
                    this.$log.error('Failed to reset password', error);
                    let errorMessage = null;

                    if (!_.isString(error)) {
                        errorMessage = 'Failed to submit password request, please try again';

                        if (!_.isNil(error.data) && error.data !== '') {
                            errorMessage = error.data;
                            if (!_.isEmpty(error.data.Message)) {
                                errorMessage = error.data.Message;
                            }
                        }
                    } else {
                        errorMessage = error;
                    }

                    this.error = errorMessage;
                })
            .finally(() => {
                this.isBusy = false;
            });
        }
    }

export default {
    template: template,
    bindings: {
        redirectTo: '@',
        message: '@'
    },
    controller: ForgotPasswordController
};